import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../../../components/Button/Button';

export type FormsOfPaymentProps = React.PropsWithChildren<{
  tableData: any;
  handleBackToResults?: any;
  handleClose?: any;
}>;

const FormsOfPaymentContent = ({
  tableData,
  handleBackToResults,
  handleClose,
}: FormsOfPaymentProps) => {
  return (
    <>
      <Button
        variant="primary-outline"
        className="order-1 order-lg-2 mt-10"
        onClick={handleBackToResults}
        leftIcon={light('chevron-left')}
      >
        Back to Results
      </Button>
      <Container className="p-11 mt-11 bg-backgroud-gray rounded-1 mb-11">
        <Row className={'justify-content-between'}>
          <Col className={'col-12 col-lg-7 text-start'}>
            <Container className={'px-0 w-100'}>
              <h5 className={'text-sm-20-lg-32 fw-light mb-0'}>
                Forms of Payment
              </h5>
            </Container>
          </Col>
          <Col className={'col-12 col-lg-3 text-end'}>
            <Container className={'px-0 w-100'}>
              <a
                className={'text-decoration-none'}
                href={`${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`}
                target={'_blank'}
                rel="noreferrer"
              >
                <Button
                  className={'w-100'}
                  size={'sm'}
                  leftIcon={light('file-download')}
                  variant={'primary-outline'}
                >
                  Download Summary
                </Button>
              </a>
            </Container>
          </Col>
        </Row>
        <Container className={'px-0 overflow-auto'}>
          <Container
            className={'px-0 overflow-hidden'}
            style={{ minWidth: 650 }}
          >
            <Row className={'mt-11 py-5 border-bottom-dark-gray'}>
              <Col className={'col-6'}>
                <span className={'text-fs-6 fw-normal text-light-grey'}>
                  Form of Payment
                </span>
              </Col>
              <Col className={'col-3'}>
                <span className={'text-fs-6 fw-normal text-light-grey'}>
                  Monthly Payment Payable to You
                </span>
              </Col>
              <Col className={'col-3'}>
                <span className={'text-fs-6 fw-normal text-light-grey'}>
                  Monthly Payment to Beneficiary After Death
                </span>
              </Col>
            </Row>

            {tableData.map((paymentData: any, i: number) => {
              return (
                <Row className={'border-bottom-light-gray-lg'} key={i}>
                  <Col className={'col-12 pt-3 pb-1'}>
                    <Row className={'py-1'}>
                      <Col className={'col-6'}>
                        <span className={'fw-normal text-fs-6'}>
                          {paymentData.title}
                        </span>
                      </Col>
                      <Col className={'col-3'}>
                        <span className={'fw-light text-fs-6'}>
                          {paymentData.contributionsWithdrawn.monthlyPayment}
                        </span>
                      </Col>
                      <Col className={'col-3'}>
                        <span className={'fw-light text-fs-6'}>
                          {
                            paymentData.contributionsWithdrawn
                              .monthlyPaymentToBeneficiary
                          }
                        </span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              );
            })}
          </Container>
        </Container>
        <Container className="p-0 d-flex justify-content-center">
          <Button
            variant="primary-outline"
            className="order-1 order-lg-2 mt-10"
            onClick={handleClose}
          >
            Close
          </Button>
        </Container>
      </Container>
    </>
  );
};

export default FormsOfPaymentContent;
